import React, { useEffect, useState } from 'react';

import { Box } from '@wds/box';
import { InputMessage } from '@wds/input-message';
import { DateInput } from '@wds/date-input';

import getComponentWithTheme from '../../../../themeProvider';
import { STRINGS } from './constants';

function DateCustomField(props) {
	const {
		id, label, value, onChange, required, readOnly, errors, setErrors, helperText,
	} = props;
	const [state, setState] = useState(null);
	const [error, setError] = useState('');

	useEffect(() => {
		if (value.length > 0) {
			try {
				const [year, month, day] = value.split('-');
				validateField(new Date(year, month - 1, day));
			} catch (err) {
				console.log('Invalid date format:', err);
				setState(null);
			}
		}
	}, []);

	useEffect(() => {
		if (errors?.[id]) {
			setError(errors[id]);
		} else {
			setError('');
		}
	}, [errors]);

	const handleChange = (e) => {
		const updatedValue = e;
		validateField(updatedValue);
	};

	const validateField = (updatedValue) => {
		setState(updatedValue);
		if (required && updatedValue.length === 0) {
			setError(errors[id]);
		} else {
			setErrors((prevErrors) => {
				const { [id]: _, ...rest } = prevErrors;
				return rest;
			});
			setError('');
			if (updatedValue) {
				onChange(updatedValue.toLocaleDateString('en-CA'));
			}
		}
	};

	return (
		getComponentWithTheme(
			<Box>
				<DateInput
					id={`${id}-input-group`}
					label={`${label} ${required ? '' : `(${STRINGS.optional})`}`}
					required={required}
					color={errors?.[id] ? 'error' : undefined}
					disabled={readOnly}
					selectedDate={state}
					onChange={handleChange}
					stretched
				/>
				{helperText && <InputMessage id={`${id}-helper-text`}>{helperText}</InputMessage>}
				{errors?.[id] && <InputMessage color='error' id={`${id}-error-text`}>{error}</InputMessage>}
			</Box>,
		)
	);
}

export default DateCustomField;
